module.exports = __webpack_public_path__ + "img/about_S.c83fc458.svg";